export default __webpack_public_path__ + "static/media/higher_icon_blockchain.4b8a7a8d.svg";